interface IParams {
  message: string;
  protocolId?: string;
}

export default function buildWhatsappMessage({ message, protocolId }: IParams) {
  if (!protocolId) return message;
  return `${message} \n\n_Protocolo: ${protocolId}_`;
}
